import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {TaskStatus} from "./misc/GenericEnums";
import {field} from "../../stem-core/state/StoreField";


@globalStore
export class SubscriptionChange extends BaseStore("subscriptionChange") {
    @field(TaskStatus) status: TaskStatus;
}
